__turbopack_context__.v({
  "column": "Footer-module-scss-module__DkSkqG__column",
  "columnTitle": "Footer-module-scss-module__DkSkqG__columnTitle",
  "columns": "Footer-module-scss-module__DkSkqG__columns",
  "contact": "Footer-module-scss-module__DkSkqG__contact",
  "copy": "Footer-module-scss-module__DkSkqG__copy",
  "cta": "Footer-module-scss-module__DkSkqG__cta",
  "ctaActions": "Footer-module-scss-module__DkSkqG__ctaActions",
  "ctaBody": "Footer-module-scss-module__DkSkqG__ctaBody",
  "ctaBottom": "Footer-module-scss-module__DkSkqG__ctaBottom",
  "ctaHeading": "Footer-module-scss-module__DkSkqG__ctaHeading",
  "footer": "Footer-module-scss-module__DkSkqG__footer",
  "item": "Footer-module-scss-module__DkSkqG__item",
  "legal": "Footer-module-scss-module__DkSkqG__legal",
  "loop": "Footer-module-scss-module__DkSkqG__loop",
  "loopPoster": "Footer-module-scss-module__DkSkqG__loopPoster",
  "loopToggle": "Footer-module-scss-module__DkSkqG__loopToggle",
  "loopVideo": "Footer-module-scss-module__DkSkqG__loopVideo",
  "videoCol": "Footer-module-scss-module__DkSkqG__videoCol",
});
